export default __webpack_public_path__ + "static/media/hn.d99bafd4.svg";